import { Grid, stepClasses, stepIndicatorClasses, Stepper as JoyStepper, styled } from '@mui/joy';

export const Wrapper = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.background.surface,
  height: '100%',
}));

export const LeftWrapper = styled(Grid)({
  padding: 32,
});

export const RightWrapper = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: 32,
  gap: 24,
  height: '100%',
  borderLeft: `2px solid ${theme.palette.background.surface}`,
  backgroundColor: theme.palette.background.surface,
}));

export const Stepper = styled(JoyStepper)(({ theme }) => ({
  '--Stepper-verticalGap': '28px',
  '--StepIndicator-size': '28px',
  '--Step-gap': '16px',
  '--Step-connectorInset': '4px',
  '--Step-connectorThickness': '2px',
  '--joy-palette-success-solidBg': theme.palette.success[400],

  [`& .${stepClasses.indicator}`]: {
    fontSize: '14px',
    fontWeight: 600,
  },

  [`& .${stepClasses.completed}`]: {
    '&::after': {
      backgroundColor: theme.palette.success.solidBg,
      marginTop: '-32px',
    },
  },

  [`& .${stepClasses.active}`]: {
    [`& .${stepIndicatorClasses.root}`]: {
      border: `2px solid ${theme.palette.background.surface}`,
      color: theme.palette.background.surface,
    },
  },

  [`& .${stepClasses.active}:not(.${stepClasses.completed})`]: {
    [`& .${stepIndicatorClasses.root}`]: {
      backgroundColor: theme.palette.primary[500],
      boxShadow: `0 0 0 1px ${theme.palette.primary[500]}`,
    },
  },

  [`& .${stepClasses.active}.${stepClasses.completed}`]: {
    [`& .${stepIndicatorClasses.root}`]: {
      boxShadow: `0 0 0 1px ${theme.palette.success.solidBg}`,
    },
  },

  [`& .${stepClasses.disabled} *`]: {
    color: theme.palette.neutral.softDisabledColor,
  },

  [`& .${stepClasses.root}:not(.${stepClasses.active}):not(.${stepClasses.completed})`]: {
    [`& .${stepIndicatorClasses.root}`]: {
      border: `1px solid ${theme.palette.primary[500]}`,
      color: theme.palette.primary[500],
    },
  },
}));
